import Text from '@molecules/Text';

import ModalComponent, { ModalProps } from '@molecules/BEOffScreen/Modal';
import { useStore } from '@data/other/withStore';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

const ModalAboutProperty = (props: ModalProps) => {
  const { t } = useTranslation();
  const { property } = useStore();

  return (
    <ModalComponent {...props} width={560} title={t('about-property')}>
      <Text html={property?.model?.description?.getText() || ''} />
    </ModalComponent>
  );
};

export default observer(ModalAboutProperty);
